import * as dateFns from 'date-fns';

import { getReadableTime } from '@order/utils';

/**
 * We want to use the same 10 minute range in all locations in the app.
 * We should round up to the next 5 minute increment.
 *
 * Examples:
 *    For inputDate = 11:03, we want 11:05-11:15.
 *    For inputDate = 11:05, we want 11:05-11:15.
 *    For inputDate = 11:07, we want 11:10-11:20.
 *    For inputDate = 11:10, we want 11:10-11:20.
 */

export const getOrderTimeRange = (inputDate?: Date) => {
  if (!inputDate || !dateFns.isValid(inputDate)) {
    return { startTime: '', endTime: '' };
  }

  const startDate = getNextTimeRangeRoundedUp(inputDate);
  const endDate = dateFns.addMinutes(startDate, TIME_RANGE_OFFSET);

  return {
    startTime: getReadableTime(startDate),
    endTime: getReadableTime(endDate),
  };
};

const getNextTimeRangeRoundedUp = (inputDate: Date) => {
  return new Date(
    Math.ceil(inputDate.getTime() / FIVE_MINS_IN_MS) * FIVE_MINS_IN_MS,
  );
};

const FIVE_MINS_IN_MS = 5 * 60 * 1000; // used to round ranges in 5mins intervals.
const TIME_RANGE_OFFSET = 10; // 10 mins.
